/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import * as React from "react";

import ColorPicker from "./ColorPicker";
import DropDown from "./DropDown";
import TextColorPicker from "./TextColorPicker";
import BgColorPicker from "./BgColorPicker";
import { useTranslation } from "react-i18next";

type Props = {
  disabled?: boolean;
  buttonAriaLabel?: string;
  buttonClassName: string;
  buttonIconClassName?: string;
  buttonLabel?: string;
  title?: string;
  stopCloseOnClickSelf?: boolean;
  color: string;
  buttonIcon?: React.ReactNode;
  showChevron?: boolean;
  isFloatingToolbar?: boolean;
  onChange?: (color: string, skipHistoryStack: boolean) => void;
};

export default function DropdownColorPicker({ disabled = false, stopCloseOnClickSelf = true, color, onChange, buttonIcon, isFloatingToolbar = false, ...rest }: Props) {
  return (
    <DropDown {...rest} disabled={disabled} buttonLabelIcon={buttonIcon} stopCloseOnClickSelf={stopCloseOnClickSelf} isFloatingToolbar={isFloatingToolbar}>
      <ColorPicker color={color} onChange={onChange} />
    </DropDown>
  );
}

export function DropdownTextColorPicker({ disabled = false, stopCloseOnClickSelf = true, color, onChange, buttonIcon, showChevron = false, isFloatingToolbar = false, ...rest }: Props) {
  const { t } = useTranslation("EditorToolbar");

  return (
    <DropDown
      {...rest}
      disabled={disabled}
      buttonLabelIcon={buttonIcon}
      stopCloseOnClickSelf={stopCloseOnClickSelf}
      showChevron={showChevron}
      isFloatingToolbar={isFloatingToolbar}
      tooltipTitle={t("text-color")}
    >
      <TextColorPicker color={color} onChange={onChange} />
    </DropDown>
  );
}

export function DropdownBgColorPicker({ disabled = false, stopCloseOnClickSelf = true, color, onChange, buttonIcon, showChevron = false, isFloatingToolbar = false, ...rest }: Props) {
  const { t } = useTranslation("EditorToolbar");
  return (
    <DropDown
      {...rest}
      disabled={disabled}
      buttonLabelIcon={buttonIcon}
      stopCloseOnClickSelf={stopCloseOnClickSelf}
      showChevron={showChevron}
      isFloatingToolbar={isFloatingToolbar}
      tooltipTitle={t("bg-color")}
    >
      <BgColorPicker color={color} onChange={onChange} />
    </DropDown>
  );
}
